<template>
	<AlertCardWrapper @action-button-click="actionButtonClick" :actionTitle="actionTitle" :titleArr="titleArr" :alert="alert">
		<template #subtitle>
			<SubTitle
				:hideIcon="hideIcon"
				:text="subtitleText"
				:icon="subtitleIcon"
				:linkText="subTitleLinkText"
				@subtitle-link-click="onSubtitleLinkClick"
			/>
		</template>
	</AlertCardWrapper>
</template>

<script>
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
export default {
	name: 'ModuleTurnedOffByError',
	mixins: [AlertTypeBaseMixin],
	computed: {
		titleArr() {
			return [{ text: 'Feature turned off due to error' }];
		},
		actionTitle() {
			return 'Open task log';
		},
		subtitleText() {
			return '[Feature name]';
		},
		subtitleIcon() {
			return 'gmail'; // TODO - return module's contexts service icon
		},
		subTitleLinkText() {
			return 'Feature details';
		},
	},
	methods: {
		actionButtonClick() {
			console.log('ModuleTurnedOffByError action clicked');
		},
		onSubtitleLinkClick() {
			console.log('ModuleTurnedOffByError subtitle action clicked');
		},
	},
};
</script>
<style lang="scss" scoped></style>
